import * as Yup from "yup";
import { ClientFilter } from "../clients/ClientFilter";
import httpClient from "../config/HttpClient";

export const EMAIL_URL = "/emails";

export interface EmailData {
  htmlText: string;
  subject: string;
  attachments: string[];
  important: boolean;
}

export interface EmailResults {
  id: string;
  senderName: string;
  sentCount: number;
  failedCount: number;
  invoiceSent: boolean;
  filter: ClientFilter;
}

export const defaultEmailData: Readonly<EmailData> = {
  htmlText: "",
  subject: "",
  attachments: [],
  important: false,
};

export const emailSchema = Yup.object().shape({
  htmlText: Yup.string().required("Turinys yra privalomas").min(1, "Turinys neturi būti tuščias"),
  subject: Yup.string().required("Laiško tema yra privaloma").min(1, "Tema neturi būti tuščia"),
});

export class EmailModel implements EmailData {
  htmlText: string = "";
  subject: string = "";
  attachments: string[] = [];
  important: boolean = false;

  constructor(data: Partial<EmailData> = {}) {
    Object.assign(this, { ...defaultEmailData, ...data });
  }

  static async sendInvoice(content: EmailData, invoiceNo: string): Promise<void> {
    await httpClient.post(`${EMAIL_URL}/invoices/${invoiceNo}/send`, content);
  }
}

export default EmailModel;
